import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MainService } from 'src/app/services/main.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-trade-agreements',
  templateUrl: './trade-agreements.page.html',
  styleUrls: ['./trade-agreements.page.scss']
})
export class TradeAgreementsPage implements OnInit {

  userPermissions: any = this.uService.userPermissions.commercial_agreements;
  filterTerm: string = ''
  filterTerm2: string = ''
  filterTerm3: string = ''
  filtersForm: FormGroup = new FormGroup({
    start_date: new FormControl(''),
    end_date: new FormControl(''),
    organization_id: new FormControl(''),
    status: new FormControl('')
  });
  organizations: any = [];
  status: any = this.uService.status;

  displayedColumns: any = [
    {variable: 'rowNumber', displayedName: 'N.'},
    {variable: 'options-trade-agreements', displayedName: 'Acciones'},
    {variable: 'organization_name', displayedName: 'Organización'},
    {variable: 'status', displayedName: 'Estado'},
    {variable: 'user_name', displayedName: 'Usuario'},
    {variable: 'charge_frequency', displayedName: 'Formato de cobro'},
    {variable: 'currency', displayedName: 'divisa'},
    {variable: 'created_at', displayedName: 'Fecha de creación'},
  ];

  dataSource: any = [];

  start_date_param: any = [];
  end_date_param: any = [];
  organization_id_param: any = [];
  status_param: any = [];

  getUrl(): string{
    return this.uService.getUrl();
  }

  getActualUrl(): string{
    return window.location.href;
  }

  setFocus(id: any) {
    var input  = document.getElementById(id);
    if(input !== null){
      input.focus();
    }
  }

  concatUrl(){
    var fields = this.uService.avoidEmptyFields(this.filtersForm);
    var concat_url = this.getActualUrl().split('?')[0] + '?';
    var jindex: number = 0;

    for (const key in fields) {
      console.log(jindex !== (Object.keys(fields).length - 1) && jindex !== 0 && Object.keys(fields).length !== 1);

      if(jindex !== 0 && Object.keys(fields).length !== 1){
        concat_url = concat_url + '&'
      }

      if(Array.isArray(fields[key])){
        fields[key].forEach((element: any, index: number) => {
          if(index === 0){
            concat_url = concat_url + key + '=' + element;
          }else{
            concat_url = concat_url + '&' + key + '=' + element;
          }
          index++;
        });
      }else{
        concat_url = concat_url + key + '=' + fields[key];
      }
      jindex++;
    }

    if(!this.uService.objectEmpty(fields)){
      location.href = concat_url;
    }
  }

  getTradeAgreements(){
    var fields: any ={
      start_date: this.start_date_param,
      end_date: this.end_date_param,
      organization_id: this.organization_id_param,
      status: this.status_param,
    };

    this.filtersForm.get('start_date').setValue(this.start_date_param);
    this.filtersForm.get('end_date').setValue(this.end_date_param);
    this.filtersForm.get('organization_id').setValue(this.organization_id_param);
    this.filtersForm.get('status').setValue(this.status_param);

    fields = this.uService.avoidEmptyFieldsJson(fields);

    this.mService.get_request('v2/commercial-agreements', fields)
    .subscribe((resp: any)=>{
      if(resp.status){
        this.dataSource = resp.items || [];
        this.organizations = resp.organizations || [];
      }else{
        if(resp.message){
          this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
          if(resp.message.includes('expirado')){
            this.uService.logOut$.next(true);
          }
        }
      }
    });
  }

  getExcel2(){
    var fields: any = this.filtersForm.value
    fields = this.uService.avoidEmptyFieldsJson(fields);

    this.mService.get_requestBlob('v2/commercial-agreements?export_excel=true', fields)
    .subscribe((resp: any)=>{
      if(resp){
        const blob = new Blob([resp], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        var anchor:any = document.getElementById('anchor');
        anchor.setAttribute('href', window.URL.createObjectURL(blob));
        anchor.setAttribute('download', 'acuerdos_comerciales.xlsx');
        anchor.click();
      }else{
        if(resp.message){
          this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
          if(resp.message.includes('expirado')){
            this.uService.logOut$.next(true);
          }
        }
      }
    });
  }

  getExcel(){
    var fields: any = this.filtersForm.value
    fields = this.uService.avoidEmptyFieldsJson(fields);
    var concat_url = `${this.getUrl()}v2/commercial-agreements?export_excel=true`;

    for (const key in fields) {
      if (Object.prototype.hasOwnProperty.call(fields, key)) {
        if(Array.isArray(fields[key])){
          fields[key].forEach(element => {
            concat_url = concat_url + '&' + key + '=' + element;
          });
        }else{
          concat_url = concat_url + '&' + key + '=' + fields[key];
        }
      }
    }
    window.open(concat_url, '_blank');
  }

  constructor(
    private mService: MainService,
    private toast: ToastrService,
    private uService: UtilsService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    let { start_date, end_date, organization_id, status } = this.route.snapshot.queryParams;
    if(start_date){
      if(Array.isArray(start_date)){
        this.start_date_param = start_date;
      }else{
        this.start_date_param.push(start_date)
      }
    }
    if(end_date){
      if(Array.isArray(end_date)){
        this.end_date_param = end_date;
      }else{
        this.end_date_param.push(end_date)
      }
    }
    if(organization_id){
      if(Array.isArray(organization_id)){
        var new_organization_id = organization_id.map((x) => Number(x));

        this.organization_id_param = new_organization_id;
      }else{
        this.organization_id_param.push(Number(organization_id));
      }
    }
    if(status){
      if(Array.isArray(status)){
        this.status_param = status;
      }else{
        this.status_param.push(status);
      }
    }

    this.getTradeAgreements();
  }

  ngAfterViewInit() {
  }

  ngOnInit(): void {}
}

